module.exports = __webpack_public_path__ + "img/image_08.104fc72d.png";